module.exports = __webpack_public_path__ + "static/media/I_bubbly_ux.ec32bab3.png";